import { API_BASE_URL, endpoints } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";

export interface WhatsAppStatus {
  provider: string;
  name: string;
  isReady: boolean;
  isConfigured: boolean;
  whatsappAvailable?: boolean;
  userMessage?: string;
  technicalDetail?: string;
}

export interface WhatsappWebStateResponse {
  credential: {
    reference: string;
    status: string;
    businessPhoneE164: string;
    lastError: string | null;
  } | null;
  qr: string | null;
  clientActive: boolean;
}

export const whatsappApi = {
  getStatus: async (): Promise<WhatsAppStatus> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.whatsapp.status}`,
      {
        method: "GET",
        headers: authHeadersForGet(),
      }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  },

  getWebState: async (): Promise<WhatsappWebStateResponse> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.whatsapp.webState}`,
      { method: "GET", headers: authHeadersForGet() }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  },

  ensureWebCredential: async (): Promise<{ reference: string }> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.whatsapp.webEnsureCredential}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify({}),
      }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return response.json();
  },

  startWeb: async (): Promise<void> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.whatsapp.webStart}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify({}),
      }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
  },

  logoutWeb: async (): Promise<void> => {
    const response = await fetch(
      `${API_BASE_URL}${endpoints.whatsapp.webLogout}`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify({}),
      }
    );
    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
  },
};
